import { render, staticRenderFns } from "./PracticeNotesDialog.vue?vue&type=template&id=596b0ca5"
import script from "./PracticeNotesDialog.vue?vue&type=script&lang=ts"
export * from "./PracticeNotesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports